import { useMemo } from 'react';

import { exportImageWidgetToPng } from '../../../../../report/widgetExportHelpers';
import type { WidgetInstanceCapabilities } from '../../../../../runtime/instanceRegistry/types';
import { useRegisterWidgetInstance } from '../../../../../runtime/instanceRegistry/useRegisterWidgetInstance';

// -- type definitions --

export interface ImageInstanceRegistrationContext {
  readonly dashboardElementId: number;
  readonly widgetId: string;
  readonly enabled: boolean;
}

// -- hook --

/**
 * Register an image widget instance.
 *
 * The following capabilities are registered:
 * - toolbar actions: edit
 * - for-report content extraction: PNG format
 */
export function useImageInstanceRegistration(
  ctx: ImageInstanceRegistrationContext
): void {
  const capabilities = useMemo<WidgetInstanceCapabilities | null>(() => {
    if (!ctx.enabled) {
      return null;
    }

    return {
      dashboardElementId: ctx.dashboardElementId,
      widgetId: ctx.widgetId,
      reportExports: [
        {
          format: 'png',
          export: async () => {
            const png = await exportImageWidgetToPng(ctx.widgetId);
            return png ?? '';
          },
        },
      ],
    };
  }, [ctx.dashboardElementId, ctx.enabled, ctx.widgetId]);

  useRegisterWidgetInstance(capabilities);
}
